import { ORDER_DIRECTION } from "core/constants/table"

export const FORM_FIELD_NAMES = {
    LANDING_URLS : "landingUrls",
}